<template>
  <div class="app-body">
    <Header></Header>
    <main class="container-fluid h-100 p-0">
      <div class="row m-0 h-100">
        <div class="col-sm-12 col-md-6 col-text p-5 h-100 justify-content-start help-text">
          <p>Our history started in 2003 when <a href="https://www.linkedin.com/in/thomalexandre/">Alexandre Thomas</a>
            published the first version of GanttProject, an open-source free project scheduling tool.
            In 2006 Dmitry Barashev took over the development and now GanttProject is
            <a href="https://project-management.zone/ranking/open-source,planning">one of the most popular free project management tools</a>.
            It is used by thousands of people worldwide in architecture, construction, engineering, media production, medical services,
            non-profit organizations, universities, etc.</p>
          <p>GanttProject Cloud is a commercial cloud service established in 2018. Its primary goal is to add modern
            collaboration facilities to GanttProject and make team work more efficient.
            It does not replace the desktop application, it rather stays as a very useful add-on for teams working on
            their projects in GanttProject.</p>
        </div>
        <div class="col-sm-12 col-md-6 col-text-dark  p-5 h-100 justify-content-start">
          <h2>Our Team</h2>
          <ul>
            <li><a class="inline-link" href="https://www.linkedin.com/in/dbarashev/">Dmitry Barashev</a>, the founder and technical lead.</li>
            <li><a class="inline-link" href="https://www.linkedin.com/in/gleb-valin-566456165/">Gleb Valin</a> and Dmitry Kazakov, software engineers who wrote a huge part of GanttProject Cloud code.</li>
            <li><a class="inline-link" href="https://www.behance.net/diowooster">Darya Solodova</a>, illustrator who authored a series of Cro-Magnon team project cartoons.</li>
          </ul>
        </div>
      </div>
    </main>
  </div>
</template>

<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import Header from '@/components/Header.vue';

@Component({
  components: {Header}
})
export default class AboutTeam extends Vue {
}
</script>

<style lang="scss">
@import 'sass/about_team';
</style>
